import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "tariff-section" }
const _hoisted_2 = { class: "tariff-content" }
const _hoisted_3 = { class: "tariff-row" }
const _hoisted_4 = { class: "price-container" }
const _hoisted_5 = {
  key: 0,
  class: "price"
}
const _hoisted_6 = { class: "tariff-group" }
const _hoisted_7 = { class: "tariff-label" }
const _hoisted_8 = { class: "price-container" }
const _hoisted_9 = {
  key: 0,
  class: "price"
}
const _hoisted_10 = { class: "unit" }
const _hoisted_11 = { class: "tariff-group" }
const _hoisted_12 = { class: "tariff-label" }
const _hoisted_13 = { class: "price-container" }
const _hoisted_14 = {
  key: 0,
  class: "price"
}
const _hoisted_15 = { class: "unit" }

import { ref, computed } from 'vue'
import { ElNotification } from 'element-plus'
import { Edit } from '@element-plus/icons-vue'

import {
  EvCarProfileFull,
  EvCarProfileUpdateableKeys,
} from '@/models/evCarProfile'
import { useEvCarsStore } from '@/store/ev-vehicles'
import { RbacAction, RbacEntity } from '@/helpers/rbac'
import useScopeCheck from '@/composables/useScopeCheck'

interface TariffField {
  key: EvCarProfileUpdateableKeys
  label: string
  unit: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EVTariffSection',
  props: {
    vehicle: {}
  },
  setup(__props: any) {

const props = __props

const evCarsStore = useEvCarsStore()
const allowedEditing = useScopeCheck(RbacAction.UPDATE, RbacEntity.CARS)

const updatingModule = computed(
  () => evCarsStore.evCarsDetails[props.vehicle.id]?.updating
)
const loadingKeys = computed(() => updatingModule.value?.loadingKeys || [])
const successKeys = computed(() => updatingModule.value?.successKeys || [])

const editingField = ref<EvCarProfileUpdateableKeys | null>(null)
const editingValue = ref<number>(0)

const startEditing = (
  key: EvCarProfileUpdateableKeys,
  currentValue: number
) => {
  editingField.value = key
  editingValue.value = currentValue
}

const cancelEditing = () => {
  editingField.value = null
  editingValue.value = 0
}

const saveEdit = async (key: EvCarProfileUpdateableKeys) => {
  try {
    await evCarsStore.updateEvVehicle(props.vehicle.id, {
      [key]: editingValue.value,
    })
    ElNotification({
      title: 'Success',
      message: `${key} updated successfully`,
      type: 'success',
    })
    editingField.value = null
  } catch (error) {
    console.error('Failed to update tariff:', error)
    ElNotification({
      title: 'Error',
      message: `Failed to update ${key}`,
      type: 'error',
    })
  }
}

const pricePerMinFields = computed<TariffField[]>(() => [
  { key: 'start_price', label: 'Start price', unit: '' },
  { key: 'pause_price_ev', label: 'Pause', unit: '/min' },
  {
    key: 'price_per_minute_up_to_100_km_ev',
    label: `Minute Package (limit ${props.vehicle.max_distance_per_minute_tariff} km)`,
    unit: '/min',
  },
  {
    key: 'price_per_minute_above_100_km_ev',
    label: 'Extra km price',
    unit: '/km',
  },
])

const pricePerHourFields = computed<TariffField[]>(() => [
  {
    key: 'price_per_hour_up_to_100_km_ev',
    label: `Hourly Package (limit ${props.vehicle.max_distance_per_hour_tariff} km)`,
    unit: '',
  },
  {
    key: 'price_per_minute_above_100_km_ev',
    label: `Minute Package (limit ${props.vehicle.max_distance_per_hour_tariff} km)`,
    unit: '/min',
  },
  {
    key: 'price_per_hour_above_100_km_ev',
    label: 'Extra km price',
    unit: '/km',
  },
])

return (_ctx: any,_cache: any) => {
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[14] || (_cache[14] = _createElementVNode("h4", { class: "section-title" }, "TARIFF", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "tariff-label" }, "Reserve", -1)),
        _createElementVNode("div", _hoisted_4, [
          (editingField.value !== 'reserve_price_ev')
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.vehicle.reserve_price_ev), 1))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_el_input_number, {
                  modelValue: editingValue.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editingValue).value = $event)),
                  min: 0,
                  controls: true,
                  precision: 2,
                  step: 0.01,
                  class: "tariff-input"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (saveEdit('reserve_price_ev')))
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode("Save")
                  ])),
                  _: 1,
                  __: [4]
                }),
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "danger",
                  onClick: cancelEditing
                }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createTextVNode("Cancel")
                  ])),
                  _: 1,
                  __: [5]
                })
              ], 64))
        ]),
        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "unit" }, "₼/min", -1))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "group-header" }, "Minute package", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pricePerMinFields.value, (field) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "tariff-row sub-row",
            key: field.key
          }, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(field.label), 1),
            _createElementVNode("div", _hoisted_8, [
              (editingField.value !== field.key)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.vehicle[field.key]), 1))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_el_input_number, {
                      modelValue: editingValue.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((editingValue).value = $event)),
                      min: 0,
                      controls: true,
                      precision: 2,
                      step: 0.01,
                      class: "tariff-input"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_el_button, {
                      size: "small",
                      type: "primary",
                      onClick: ($event: any) => (saveEdit(field.key))
                    }, {
                      default: _withCtx(() => _cache[8] || (_cache[8] = [
                        _createTextVNode("Save")
                      ])),
                      _: 2,
                      __: [8]
                    }, 1032, ["onClick"]),
                    _createVNode(_component_el_button, {
                      size: "small",
                      type: "danger",
                      onClick: cancelEditing
                    }, {
                      default: _withCtx(() => _cache[9] || (_cache[9] = [
                        _createTextVNode("Cancel")
                      ])),
                      _: 1,
                      __: [9]
                    })
                  ], 64))
            ]),
            _createElementVNode("span", _hoisted_10, "₼" + _toDisplayString(field.unit), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "group-header" }, "Hourly package", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pricePerHourFields.value, (field) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "tariff-row sub-row",
            key: field.key
          }, [
            _createElementVNode("span", _hoisted_12, _toDisplayString(field.label), 1),
            _createElementVNode("div", _hoisted_13, [
              (editingField.value !== field.key)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.vehicle[field.key]), 1))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_el_input_number, {
                      modelValue: editingValue.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((editingValue).value = $event)),
                      min: 0,
                      controls: true,
                      precision: 2,
                      step: 0.01,
                      class: "tariff-input"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_el_button, {
                      size: "small",
                      type: "primary",
                      onClick: ($event: any) => (saveEdit(field.key))
                    }, {
                      default: _withCtx(() => _cache[11] || (_cache[11] = [
                        _createTextVNode("Save")
                      ])),
                      _: 2,
                      __: [11]
                    }, 1032, ["onClick"]),
                    _createVNode(_component_el_button, {
                      size: "small",
                      type: "danger",
                      onClick: cancelEditing
                    }, {
                      default: _withCtx(() => _cache[12] || (_cache[12] = [
                        _createTextVNode("Cancel")
                      ])),
                      _: 1,
                      __: [12]
                    })
                  ], 64))
            ]),
            _createElementVNode("span", _hoisted_15, "₼" + _toDisplayString(field.unit), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})